function toggleAccordion(element, isDetail = false) {
    var $element = $(element);
    var textElement = $element.parent().parent().find('.text');
    var chevron = $element.find('.chevron');
    chevron.css('transform', chevron.css('transform') === 'rotate(180deg)' ? 'rotate(0deg)' : 'rotate(180deg)');
    textElement.toggleClass('hidden');
    $element.parents('.accordion-wrapper').toggleClass('active');

    // if elements.parents('.accordion-wrapper') siblings have class active, remove it
    if ($element.parents('.accordion-wrapper').siblings().hasClass('active')) {
        $element.parents('.accordion-wrapper').siblings().css('marginTop', '0px');
        $element.parents('.accordion-wrapper').siblings().removeClass('active');
        $element.parents('.accordion-wrapper').siblings().find('.text').addClass('hidden');
        $element.parents('.accordion-wrapper').siblings().find('.chevron').css('transform', 'rotate(0deg)');
    }

    if (window.innerWidth > 1024 && !isDetail) {
        if (!textElement.hasClass('hidden')) {
            toggleMargin($element.parents('.accordion-wrapper'));
        } else {
            var $accordionWrappers = $('.accordion-wrapper');
            var index = $accordionWrappers.index($element.parents('.accordion-wrapper'));

            if (index === 0) {
                $accordionWrappers.eq(3).css('marginTop', '0px');
            }

            if (index === 1) {
                $accordionWrappers.eq(2).css('marginTop', '0px');
            }
        }
    }
}

function toggleMargin(clickedElement) {
    var $accordionWrappers = $('.accordion-wrapper');
    var index = $accordionWrappers.index(clickedElement);

    if (index === 0) {
        $accordionWrappers.eq(3).css('marginTop', -($(clickedElement).find('.text').outerHeight() + 32) + 'px');
    }

    if (index === 1) {
        $accordionWrappers.eq(2).css('marginTop', -($(clickedElement).find('.text').outerHeight() + 32) + 'px');
    }

}